import React from 'react';

import { PropertyGroup, Heading } from '../../../components';

import css from '../ListingPage.module.css';

const createFilterOptions = options => options.map(o => ({ key: `${o.option}`, label: o.label }));

const ProducerTypeWithIcons = ({ listing, listingConfig }) => {
  const producerTypeSelectedValues = listing.attributes.publicData.producer_type_category;
  const fieldConfig = listingConfig.listingFields.find(c => c.key === 'producer_type_category');

  if (!producerTypeSelectedValues || !fieldConfig) return null;

  const { enumOptions, showConfig } = fieldConfig;

  return (
    <div className={css.sectionMultiEnum}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {showConfig.label}
      </Heading>
      <PropertyGroup
        id="producer_type_category"
        options={createFilterOptions(enumOptions)}
        selectedOptions={producerTypeSelectedValues}
        twoColumns={enumOptions.length > 5}
      />
    </div>
  );
};

export default ProducerTypeWithIcons;
